module.exports = __webpack_public_path__ + "img/eat_out_03.3b841d70.jpg";